import axios from 'axios'
import router from '@/router'

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: { 'Content-Type': 'application/json' }
})

// Adjunta JWT en cada request e inyecta Lenguaje si el llamador lo solicita
apiClient.interceptors.request.use(config => {
  const jwt = localStorage.getItem('jwt')
  if (jwt) config.headers.Authorization = `Bearer ${jwt}`

  // Vista del portal desde la que se origina la petición (para trazabilidad del log).
  config.headers['X-Origen-Vista'] = router.currentRoute.path

  if (config.withLenguaje) {
    const lang = localStorage.getItem('language') || 'ES'
    config.params = { ...config.params, Lenguaje: lang }
  }

  return config
})

// Maneja 401 globalmente:
// - Si el servidor devuelve un mensaje propio (lógica de negocio), se propaga el error
//   para que el componente lo muestre (credenciales inválidas, token expirado, etc.)
// - Si no hay mensaje (401 del middleware JWT por sesión vencida), redirige al login
apiClient.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      const hasServerMessage = !!error.response?.data?.message
      if (!hasServerMessage) {
        const keysToKeep = ['language', 'languageInfo', 'ES', 'EN', 'IT', 'AR']
        Object.keys(localStorage)
          .filter(k => !keysToKeep.includes(k))
          .forEach(k => localStorage.removeItem(k))
        router.push('/login')
      }
    }
    return Promise.reject(error)
  }
)

export default apiClient
